import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment';

interface TextoLegal {
  texto_legal_p1_pre: string;
  texto_legal_p1_post: string;
  texto_legal_p2_normal: string;
  texto_legal_p2_negrita: string;
}

const DEFAULTS: TextoLegal = {
  texto_legal_p1_pre: 'De acuerdo al incumplimiento debidamente comprobado, se procede a notificar bajo apercibimiento legal en los términos de la ley 24642, 23551 y Ley 23660 del monto deudor arriba consignado, el que deberá ser depositado a favor de U.R.G.A.R.A. dentro del plazo de ',
  texto_legal_p1_post: ' días.',
  texto_legal_p2_normal: 'En la determinación del mismo se ha tenido en cuenta los Decretos y Resoluciones insertas al pie de cada ítem y los Artículos 744, 776, 777 y concordantes del Código Civil, haciendo el Sindicato la más amplia y expresa reserva de derechos, incluido el de solicitar la aplicación de la Ley 23771 (Penal Tributaria). Déjese expresa constancia que la presente ',
  texto_legal_p2_negrita: 'no implica en modo alguno el reconocimiento por otras deudas que pudieran detectarse por los mismos u otros periodos.'
};

@Component({
  selector: 'app-texto-legal',
  templateUrl: './texto-legal.component.html',
  styleUrls: ['./texto-legal.component.css']
})
export class TextoLegalComponent implements OnInit {

  textos: TextoLegal = {
    texto_legal_p1_pre: DEFAULTS.texto_legal_p1_pre,
    texto_legal_p1_post: DEFAULTS.texto_legal_p1_post,
    texto_legal_p2_normal: DEFAULTS.texto_legal_p2_normal,
    texto_legal_p2_negrita: DEFAULTS.texto_legal_p2_negrita
  };

  activo: boolean = true;
  loading: boolean = false;
  guardando: boolean = false;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.cargarTextos();
  }

  cargarTextos() {
    this.loading = true;
    this.http.get<TextoLegal>(`${environment.backendUrl}/api/texto-legal`)
      .subscribe(
        data => {
          if (data['texto_legal_p1_pre'] !== undefined) { this.textos.texto_legal_p1_pre = data['texto_legal_p1_pre']; }
          if (data['texto_legal_p1_post'] !== undefined) { this.textos.texto_legal_p1_post = data['texto_legal_p1_post']; }
          if (data['texto_legal_p2_normal'] !== undefined) { this.textos.texto_legal_p2_normal = data['texto_legal_p2_normal']; }
          if (data['texto_legal_p2_negrita'] !== undefined) { this.textos.texto_legal_p2_negrita = data['texto_legal_p2_negrita']; }
          this.activo = data['texto_legal_activo'] !== '0';
          this.loading = false;
        },
        error => {
          console.error('[TextoLegal] Error al cargar textos:', error);
          this.snackBar.open('Error al cargar el texto legal. Se muestran los valores por defecto.', 'Cerrar', { duration: 4000 });
          this.loading = false;
        }
      );
  }

  guardarTodo() {
    this.guardando = true;
    const claves = [
      'texto_legal_p1_pre',
      'texto_legal_p1_post',
      'texto_legal_p2_normal',
      'texto_legal_p2_negrita'
    ];
    this.guardarSecuencial(claves, 0);
  }

  private guardarSecuencial(claves: string[], index: number) {
    if (index >= claves.length) {
      this.guardando = false;
      this.snackBar.open('Texto legal guardado correctamente', 'Cerrar', { duration: 3000 });
      return;
    }
    const clave = claves[index];
    const valor = this.textos[clave as keyof TextoLegal];

    this.http.put(`${environment.backendUrl}/api/texto-legal/${clave}`, { valor: valor })
      .subscribe(
        () => {
          this.guardarSecuencial(claves, index + 1);
        },
        error => {
          console.error('[TextoLegal] Error al guardar ' + clave + ':', error);
          this.guardando = false;
          this.snackBar.open('Error al guardar el texto legal', 'Cerrar', { duration: 3000 });
        }
      );
  }

  toggleActivo() {
    this.activo = !this.activo;
    const valor = this.activo ? '1' : '0';
    this.http.put(`${environment.backendUrl}/api/texto-legal/texto_legal_activo`, { valor: valor })
      .subscribe(
        () => {
          const msg = this.activo ? 'Texto legal activado' : 'Texto legal desactivado';
          this.snackBar.open(msg, 'Cerrar', { duration: 3000 });
        },
        error => {
          console.error('[TextoLegal] Error al cambiar estado:', error);
          this.activo = !this.activo;
          this.snackBar.open('Error al cambiar el estado del texto legal', 'Cerrar', { duration: 3000 });
        }
      );
  }

  restaurarDefecto(clave: keyof TextoLegal) {
    this.textos[clave] = DEFAULTS[clave];
    this.snackBar.open('Valor restaurado al texto original. Recuerde guardar.', 'Cerrar', { duration: 3000 });
  }
}
